export const TRACKING_EVENTS = {
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',

  INVITE_USER: 'INVITE_USER',
  REMOVE_USER: 'REMOVE_USER',
  REMOVE_INVITE: 'REMOVE_INVITE',
  UPDATE_USER_SCOPE: 'UPDATE_USER_SCOPE',
  UPDATE_USER_ROLE: 'UPDATE_USER_ROLE',
  UPDATE_SOURCE_PERMISSION: 'UPDATE_SOURCE_PERMISSION',

  UPLOAD_FILE: 'UPLOAD_FILE',

  APPLY_FILTER: 'APPLY_FILTER',

  EXPLORE_MEASURES: 'EXPLORE_MEASURES',
  ASK_WITH_AI: 'ASK_WITH_AI',

  OPEN_MEASURE_DEFINITION: 'OPEN_MEASURE_DEFINITION',
  OPEN_MEASURE_EXPLORE: 'OPEN_MEASURE_EXPLORE',
  OPEN_MEASURE_BENCHMARK: 'OPEN_MEASURE_BENCHMARK',

  APPLY_BENCHMARK_SEGMENT: 'APPLY_BENCHMARK_SEGMENT',
  SPREAD_THE_WORD_BENCHMARK: 'SPREAD_THE_WORD_BENCHMARK',

  OPEN_DRILLDOWN: 'OPEN_DRILLDOWN',
  OPEN_DRILLDOWN_IN_TABLE_VIEW: 'OPEN_DRILLDOWN_IN_TABLE_VIEW',

  LEGAL_REPORT_CREATION: 'LEGAL_REPORT_CREATION',
  LEGAL_REPORT_EDIT: 'LEGAL_REPORT_EDIT',
  LEGAL_REPORT_SHARE: 'LEGAL_REPORT_SHARE',
  LEGAL_REPORT_PUBLISH: 'LEGAL_REPORT_PUBLISH',
  LEGAL_REPORT_OPEN_EXPLORER_VIEW: 'LEGAL_REPORT_OPEN_EXPLORER_VIEW',
  LEGAL_REPORT_INSERT_FROM_EXPLORER: 'LEGAL_REPORT_INSERT_FROM_EXPLORER'
}
